import { IInstallment } from "../interfaces";
import { decimal } from "../../utils/DecimalPrecision";

class InstallmentsModel {
  public dateRef: Date;
  private _installments: IInstallment[] = [];
  private _installmentsLinked: IInstallment[] = [];
  private _total: number = 0;
  private _totalLinked: number = 0;

  constructor(dateRef: Date, installments: IInstallment[] = []) {
    this._installments = recreateCode(installments);
    this._installmentsLinked = installments.filter((installment) =>
      Boolean(installment.measurementId)
    );

    this.dateRef = dateRef;
    this._total = calcInstallmentTotal(installments);
    this._totalLinked = calcInstallmentTotal(this._installmentsLinked);
  }

  get installments(): IInstallment[] {
    return this._installments.map((installment) => ({ ...installment }));
  }

  get installmentsLinked(): IInstallment[] {
    return this._installmentsLinked.map((installment) => ({ ...installment }));
  }

  get quantity(): number {
    return this._installments.length;
  }

  get quantityLinked(): number {
    return this._installmentsLinked.length;
  }

  get total(): number {
    return this._total;
  }

  get totalLinked(): number {
    return this._totalLinked;
  }

  get balanceWithoutMeasurement(): number {
    return this._installments.reduce((sum, installment) => {
      if (installment.measurementId)
        sum = decimal(sum).subtract(installment.value).toNumber();
      return sum;
    }, this._total);
  }

  getLastMaturityDate(): Date {
    return this._installmentsLinked[this.quantityLinked - 1].maturityDate;
  }

  setInstallmentMaturityDate(installmentId: number, newDate: Date) {
    const installment = this.findInstallment(installmentId);
    if (installment) installment.maturityDate = newDate;
  }

  setInstallmentsMeasurement(installments: number[], measurementId: string) {
    installments.forEach((installmentId) => {
      const installment = this.findInstallment(installmentId);
      if (installment) installment.measurementId = measurementId;
    });
  }

  removeInstallmentsMeasurement(measurementId: string) {
    this._installments.forEach((installment) => {
      if (installment.measurementId === measurementId)
        installment.measurementId = undefined;
    });
  }

  findInstallment(id: number): IInstallment | undefined {
    return this._installments.find((installment) => installment.id === id);
  }
}

export function calcInstallmentTotal(installments: IInstallment[]): number {
  return decimal(0)
    .sum(...installments.map((inst) => inst.value))
    .toNumber();
}

export function recreateCode(installments: IInstallment[]): IInstallment[] {
  return installments.map((installment, index) => {
    installment.id = index + 1;
    return installment;
  });
}

export default InstallmentsModel;
